import * as qs from "query-string";
import { v4 as uuidv4 } from "uuid";

import { AddToCartPayload, ProductBuilderMachineContext } from "../types";
import { getAddonProducts } from "./getAddonProducts";
import { getLineItems } from "./getLineItems";

type GetAddToCartPayload = (
  context: ProductBuilderMachineContext
) => AddToCartPayload;

export const getAddToCartPayload: GetAddToCartPayload = (context) => {
  const {
    quantity,
    productWithMeasurements,
    custom: { shipping, configuration = "", roomName },
  } = context;
  const currentVariant = productWithMeasurements
    ? productWithMeasurements.data.filter(
        ({ attributes: { freight } }) => freight === shipping
      )
    : null;

  const parentProductTitle =
    currentVariant && currentVariant[0].attributes.product_title
      ? currentVariant[0].attributes.product_title
      : "";

  const getUrl = () => {
    const url = qs.parseUrl(window.location.href).url;
    const currentParams = qs.parse(window.location.search);
    const newParams = {
      ...currentParams,
    };
    const newUrl = `${url}?${qs.stringify(newParams)}`;
    return newUrl;
  };

  let products: any = [];
  const upi = uuidv4();
  const makeAnotherUrl = getUrl();
  // const isCurtain = currentVariant?.[0]?.type;
  const isCurtain = context.products[0]?.type === "Curtain";

  if (configuration.includes("Centre Opening") && !isCurtain) {
    products = ["Left", "Right"].map((curtainSide, i) => {
      if (i === 0) {
        return {
          quantity,
          id: currentVariant ? currentVariant[0].attributes.id : 0,
          properties: {
            ...getLineItems(context),
            "Curtain Side": curtainSide,
            _upi: upi,
            _makeAnotherUrl: makeAnotherUrl,
          },
        };
      } else {
        return {
          quantity,
          id: currentVariant ? currentVariant[0].attributes.id : 0,
          properties: {
            "Curtain Side": curtainSide,
            _makeAnotherUrl: makeAnotherUrl,
            _linked_product: true,
            _upi: upi,
          },
        };
      }
    });
  } else if (window.location.pathname.includes("roller-day-night") === true) {
    products = ["Day Roller", "Night Roller"].map((rollerDay, i) => {
      if (i === 0) {
        return {
          quantity,
          id: currentVariant ? currentVariant[i].attributes.id : 0,
          properties: {
            ...getLineItems(context),
            "Roller Blind": rollerDay,
            _upi: upi,
            _makeAnotherUrl: makeAnotherUrl,
          },
        };
      } else {
        return {
          quantity,
          id: currentVariant ? currentVariant[i].attributes.id : 0,
          properties: {
            "Roller Blind": rollerDay,
            _makeAnotherUrl: makeAnotherUrl,
            _linked_product: true,
            _upi: upi,
          },
        };
      }
    });
    products.push({
      quantity,
      id: 38087450525869,
      properties: {
        _upi: upi,
        "Product for": `${parentProductTitle} - Room: ${roomName}`,
        _makeAnotherUrl: makeAnotherUrl,
      },
    });
  } else {
    products.push({
      quantity,
      id: currentVariant ? currentVariant[0].attributes.id : 0,
      properties: {
        ...getLineItems(context),
        _upi: upi,
        _makeAnotherUrl: makeAnotherUrl,
      },
    });
  }

  const addonProducts = getAddonProducts(
    context,
    upi,
    roomName,
    parentProductTitle
  );

  const payload = {
    items: [...products, ...addonProducts],
  };

  return payload;
};
